export class updateProfileModel{
id: number;
fullName: string;
email: string;
cityId:number;
areaId:number;
address:string;
gender:string;
birthdate:Date;
mobileType:string;
hearAbout:string;
brandId:number;
modelId:number;
oilProduct:string;
haveSmartPhone!:boolean;
username:string;
mobileNumber :string;
}
